export const classDescriptions: string[] = [
  //0 index
  "", 

  //class1
  `Chemical products for use in industry, science, photography, as well as in agriculture, horticulture and forestry; unprocessed artificial resins, unprocessed plastics; fire extinguishing and fire prevention compositions; tempering and soldering preparations; tanning substances; adhesives for industrial purposes; putties and other paste fillers; compost, manures, fertilizers; biological preparations for use in industry and science.`,

  //class2
  `Paints, varnishes, lacquers; preservatives against rust and against deterioration of wood; colorants, dyes; inks for printing, marking and engraving; raw natural resins; metals in foil and powder form for painters, decorators, printers and artists.`,

  //class3
  `Non-medicated cosmetics and toiletry preparations; non-medicated dentifrices; perfumery, essential oils; cleaning, polishing and abrasive preparations; soaps; washing and bleaching preparations.`,

  //class4
  `Industrial oils and greases, wax; lubricants; dust absorbing, wetting and binding compositions; fuels and illuminants; candles and wicks for lighting.`,

  //class5
  `Pharmaceuticals, medical and veterinary preparations; sanitary preparations for medical purposes; dietetic food and substances adapted for medical or veterinary use, baby food; food supplements for humans and animals; plasters, materials for dressings; dental filling materials and impression materials; disinfectants; preparations for destroying vermin; fungicides, herbicides.`,

  //class6
  `Common metals and their alloys, ores; metal materials for building and construction; transportable buildings of metal; cables and wires of common metal [not for electrical purposes]; small items of metal hardware; metal containers for storage or transport; safes.`,

  //class7
  `Machines, machine tools and power-operated tools; motors and engines, except for land vehicles; couplings and transmission components, except for land vehicles; agricultural implements, other than hand-operated hand tools; incubators for eggs; vending machines.`,

  //class8
  `Hand-operated hand tools and implements; cutlery, side arms; razors.`,

  //class9
  `Scientific, research, navigation, surveying, photographic, cinematographic, audiovisual, optical, weighing, measuring, signaling, detection, testing, inspection, life-saving and teaching apparatus and instruments; apparatus and instruments for conducting, switching, transforming, accumulating, regulating or controlling electricity; apparatus and instruments for recording, transmission, reproduction or processing of sound, images or data; recorded and downloadable media, computer software; blank digital or analogue recording and storage media; mechanisms for coin-operated apparatus; cash registers, calculating devices; computers and computer peripheral devices; diving suits, divers’ masks, earplugs for divers, nose clips for divers and swimmers, diving gloves, breathing apparatus for underwater swimming; fire extinguishers.`,

  //class10
  `Surgical, medical, dental and veterinary apparatus and instruments; artificial limbs, eyes and teeth; orthopedic articles; suture materials; therapeutic and assistive devices adapted for the disabled; massage apparatus; apparatus, devices and articles for babies; apparatus, devices and articles for sexual activity.`,

  //class11
  `Apparatus and installations for lighting, heating, cooling, steam generating, cooking, drying, ventilating, water supply and sanitary purposes.`,

  //class12
  `Vehicles; apparatus for locomotion by land, air or water.`,

  //class13
  `Firearms; ammunition and projectiles; explosives; fireworks.`,

  //class14
  `Precious metals and their alloys; jewelry, precious and semi-precious stones; horological and chronometric instruments.`,

  //class15
  `Musical instruments; music stands and stands for musical instruments; conductors’ batons.`,

  //class16
  `Paper and cardboard; printed matter; bookbinding material; photographs; stationery and office requisites, except furniture; adhesives for stationery or household purposes; artists’ materials; paint brushes; instructional and teaching materials; plastic sheets, films and bags for wrapping and packaging; printing type, printing blocks.`,

  //class17
  `Unprocessed and semi-processed rubber, gutta-percha, gum, asbestos, mica; substitutes for all these materials; plastics and resins in extruded form for use in manufacture; packing, stopping and insulating materials; flexible pipes, tubes and hoses, not of metal.`,

  //class18
  `Leather and imitations of leather; animal skins and hides; luggage and carrying bags; umbrellas and parasols; walking sticks; whips, harness and saddlery; collars, leashes and clothing for animals.`,

  //class19
  `Materials, not of metal, for building and construction; rigid pipes, not of metal, for building; asphalt, pitch, tar and bitumen; transportable buildings, not of metal; monuments, not of metal.`,

  //class20
  `Furniture, mirrors, picture frames; containers, not of metal, for storage or transport; unworked or semi-worked bone, horn, whalebone or mother-of-pearl; shells; meerschaum; amber.`,

  //class21
  `Household or kitchen utensils and containers; cookware and tableware, except knives, forks and spoons; combs and sponges; brushes, except paintbrushes; brush-making materials; cleaning instruments; unworked or semi-worked glass, except building glass; glassware, porcelain and earthenware.`,

  //class22
  `Ropes and string; nets; tents and tarpaulins; awnings of textile or synthetic materials; sails; sacks for the transport and storage of materials in bulk; padding and stuffing materials, except of paper, cardboard, rubber or plastics; raw fibrous textile materials and substitutes therefor.`,

  //class23
  `Yarns and threads for textile use.`,

  //class24
  `Textiles and substitutes for textiles; household linen; curtains of textile or plastic.`,

  //class25
  `Clothing, footwear, headgear.`,

  //class26
  `Lace, braid and embroidery, ribbons and bows; buttons, hooks and eyes, pins; artificial flowers; hair decorations; false hair.`,

  //class27
  `Carpets, mats and matting, linoleum and other materials for covering existing floors; wall hangings, not of textile.`,

  //class28
  `Games, toys and playthings; video game apparatus; gymnastic and sporting articles; Christmas tree decorations.`,

  //class29
  `Meat, fish, poultry and game; meat extracts; preserved, frozen, dried and cooked fruits and vegetables; jellies, jams, compotes; eggs; milk, cheese, butter, yoghurt and other milk products; edible oils and fats.`,

  //class30
  `Coffee, tea, cocoa and artificial coffee; rice, pasta and noodles; tapioca and sago; flour and preparations made from cereals; bread, pastry and confectionery; chocolate; ice cream, sorbets and other edible ices; sugar, honey, treacle; yeast, baking powder; salt, seasonings, spices, preserved herbs; vinegar, sauces and condiments; ice [frozen water].`,

  //class31
  `Raw and unprocessed agricultural, aquacultural, horticultural and forestry products; raw and unprocessed grains and seeds; fresh fruits and vegetables, fresh herbs; natural plants and flowers; bulbs, seedlings and seeds for planting; live animals; foodstuffs and beverages for animals; malt.`,

  //class32
  `Beers; non-alcoholic beverages; mineral and aerated waters; fruit beverages and fruit juices; syrups and other non-alcoholic preparations for making beverages.`,

  //class33
  `Alcoholic beverages, except beers; alcoholic preparations for making beverages.`,

  //class34
  `Tobacco and tobacco substitutes; cigarettes and cigars; electronic cigarettes and vaporizers for smokers; smokers’ articles; matches.`,

  //class35
  `Advertising; business management, organization and administration; office functions.`,

  //class36
  `Insurance; financial, monetary and banking services; real estate affairs.`,

  //class37
  `Building construction; repair; installation services; mining, oil and gas drilling.`,

  //class38
  `Telecommunication services.`,

  //class39
  `Transport; packaging and storage of goods; travel arrangement.`,

  //class40
  `Treatment of materials; recycling of waste and trash; air purification and water treatment; printing services; food and drink preservation.`,

  //class41
  `Education; providing of training; entertainment; sporting and cultural activities.`,

  //class42
  `Scientific and technological services and research and design relating thereto; industrial analysis, industrial research and industrial design services; quality control and authentication services; design and development of computer hardware and software.`,

  //class43
  `Services for providing food and drink; temporary accommodation.`,

  //class44
  `Medical services; veterinary services; hygienic and beauty care for human beings or animals; agriculture, aquaculture, horticulture and forestry services.`,

  //class45
  `Legal services; security services for the physical protection of tangible property and individuals; dating services; providing social networking services via the Internet; funeral services; babysitting services.`
]
